


   

function MuestraCalendario(){
  var tipo="";
  tipo= window.Rebuy.SmartCart.cart.attributes['Tipo'];  
  var muestra = (tipo!="EXPRESS");  
  return muestra;  
} 
function ObtenTotalSinEnvio()
{
  const SmartCart = window.Rebuy.SmartCart;
  var itms=SmartCart.hiddenItems();
  var montoenvio = 0;
  if(itms.length>0) 
  {
    var itm=itms[0];
    montoenvio = itm.price ;    
  }  
  var env = SmartCart.items().find(({title})=>title.includes('Envío'));
  
  if(env){  
  return SmartCart.subtotalNumber() - env.final_line_price;
  }
  return SmartCart.subtotalNumber();
}
function MuestraLeyendaInmediato()
{
  var tipo="";
  tipo= window.Rebuy.SmartCart.cart.attributes['Tipo'];  
  var muestra = (tipo=="EXPRESS");  
  return muestra;  
}
function MuestraLeyendaHorarioAbierto()
{
  var tipo="";
  tipo= window.Rebuy.SmartCart.cart.attributes['Tipo'];  
  var muestra = (tipo=="ABIERTO" || tipo=="GRATIS");  
  return muestra;  
}
function MuestraAdvertenciaDia()
{
    return false;
}
function MuestraAdvertenciaRango()
{
   var tipo= window.Rebuy.SmartCart.cart.attributes['Tipo'];  
  var rango = window.Rebuy.SmartCart.cart.attributes['Rango'];  
  var muestra = (tipo=="PROGRAMADO" && (rango == null || rango =="")) ;  
  return muestra;    
}
function MuestraRango()
{
  
  var tipo = window.Rebuy.SmartCart.cart.attributes['Tipo'];  
  var muestra = (tipo=="PROGRAMADO");  
    return muestra;  
   if(document.getElementsByClassName("HoraRangoEntrega").length>0)
    {
      r = document.getElementsByClassName("HoraRangoEntrega")[0];
      
         
      if(!r.classList.contains('changeEvent'))
      {
          r.classList.add("changeEvent");
          r.addEventListener("onchange", seleccionaRango(this.value), {once:true});   

      }
    }
  return muestra;  
}
function OcultaAbierto()
{
  return ObtenTotalSinEnvio() >= 150000;  
}
function OcultaGratis()
{
  return ObtenTotalSinEnvio() <150000;
  
}

function botonActivo(tipo)
{
  const SmartCart = window.Rebuy.SmartCart;
  var itms=SmartCart.hiddenItems();
  
  if(itms.length<=0 && tipo=='') return true;
    if(itms.length<=0) return false;
  var itm=itms[0];
  var elegido="";  
   switch (itm.id.toString()) {
    case "43213443236063":
      elegido="EXPRESS"
      break;
    case "43213437993183":
       elegido="GRATIS";
      break;
    case "43213440024799":
       elegido="PROGRAMADO"
      break;
    case "43255599562975":      
       elegido="ABIERTO";
      break;
     default:
       elegido="";
       
  }
  if(tipo=="" && elegido=="GRATIS" && OcultaGratis())
  {
  //  console.log('gratis seleccionado y oculto');
    return true;
  }
  if(tipo=="" && elegido=="ABIERTO" && OcultaAbierto())
  {
   // console.log('abierto seleccionado y oculto');
    return true;
  }
  
  return elegido==tipo;
}
function Abierto() {
  console.log("clickAbierto");
  var dia = ObtenDiaDefault();
  var rango = "";
  addEnvio("43255599562975", {
    Tipo: "ABIERTO",
    IdTipo: "43255599562975",
    Dia: dia,
    Rango: rango,
  }); 
}

function Programado() {
  console.log("clickProgramado");
  var dia = ObtenDiaDefault();
  var rango = "";
  addEnvio("43213440024799", {
    Tipo: "PROGRAMADO",
    IdTipo: "43213440024799",
    Dia: dia,
    Rango: rango,
  });  
}
function Express() {
  console.log("clickExpress");
  var meses = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio",
          "agosto", "septiembre", "octubre", "noviembre", "diciembre"
        ];
       
  var dia =  new Date().getDate() + ' de ' + meses[new Date().getMonth()];
    var dianum = dia.substring(0, dia.indexOf(' '));
  if(dianum.length==1) dia = '0'+dia;
  var rango = "";
  addEnvio("43213443236063", {
    Tipo: "EXPRESS",
    IdTipo: "43213443236063",
    Dia: dia,
    Rango: rango,
  });  
}

function RestringeExpress()
{
  var ahora = new Date();
    var hora =new Date().getHours()*100 + new Date().getMinutes();
  var dia = ahora.getDay();
  
  if(hora >=1400 || hora <0900 || dia == 6 || dia == 0)
  {
    /* console.log('express restringido '+ hora);console.log(hora); console.log(dia);*/
    return true;
  }
  
    else{
    /*  console.log('express NO restringido '+ hora); console.log(hora); console.log(dia);*/
    }
  

  var hoy=new Date(); 
        
          var fechas= ['30/10/2026'];
          console.log(fechas);
           const options = {  
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  separator: "/"
};
          /*console.log(hoy.toLocaleDateString('es-MX', options)); */
  if(fechas.includes(hoy.toLocaleDateString('es-MX', options)))
  {
    /*console.log(hoy + '| HOY ES DESACTIVADO EXPRESS');*/
    return true;
  }
  return false;
}
function ObtenDiaDefault(){
  console.log('ObtenDiaDefault');
   const SmartCart = window.Rebuy.SmartCart;
      var tipo = SmartCart.cart.attributes["Tipo"];
  var hora =new Date().getHours()*100 + new Date().getMinutes();
   var diasadicionales = 0;
       console.log(hora + ' <> '+ 1200);
       console.log('TipoAP' + tipo);
  var hoy=new Date(); 
        
          var fechas= ['30/10/2026'];
          console.log(fechas);
           const options = {  
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  separator: "/"
};
          console.log(hoy.toLocaleDateString('es-MX', options));
       if( hoy.getDay() == 6) 
         diasadicionales+=2;
      else if( hoy.getDay() == 7) 
           diasadicionales +=1;
       else if(tipo!="EXPRESS" && hora >=1200 && hoy.getDay() == 5) 
         diasadicionales+=3;
      else if (tipo!="EXPRESS" && hora  >=1200) 
        diasadicionales++;

        if(fechas.includes(hoy.toLocaleDateString('es-MX', options)))
  {
    console.log(hoy + '| HOY  ES DESACTIVADO');
  
    if(hora>1200)
    {
      console.log('HOY DESACTIVADO > 1200');
    
    diasadicionales--;
    }
    else {
      console.log('HOY DESACTIVADO < 1200');
hoy.setDate(hoy.getDate()+1);

    }
  }
console.log('diasadicionales' +' ObtenDiaDefault '+ diasadicionales);
      var f = new Date();
      console.log('nuevafdefault | ' + (hoy.getDate() + diasadicionales));
      f.setDate(hoy.getDate() + diasadicionales);
        
      console.log('nueva f default: ' + f);
      var  mm = f.getMonth()+1;    
      console.log('Mes: ' +mm);
      var dd = f.getDate(); 
       
  var dia=  [(dd>9 ? '' : '0') + dd,'de',meses[mm-1]].join(' ');
  			console.log('diadefault '+dia);
  return dia;
}
function Gratis() {
  console.log("clickGratis");
  var dia = ObtenDiaDefault();
  var rango = "";
  addEnvio("43213437993183", {
    Tipo: "GRATIS",
    IdTipo: "43213437993183",
    Dia: dia,
    Rango: rango,
  });  
}
function addEnvio(IdTipo, attributes) {
  console.log('agregandoEnvio' + IdTipo);
  var existe = false;
  const SmartCart = window.Rebuy.SmartCart;
  var tipo = SmartCart.cart.attributes["Tipo"];

    switch (IdTipo) {
    case "43213443236063":      
      tipo = "EXPRESS";
      break;
    case "43213437993183":      
      tipo = "GRATIS";      
      break;
    case "43213440024799":      
      tipo = "PROGRAMADO";
      break;
    case "43255599562975":
      tipo = "ABIERTO";
      break;
  }
  console.log('Agregando --'+tipo);
console.log(attributes);
  let formData = {};
  
  var x = $.getJSON("/cart.js",  function (res) 
  {
    window.existe = false;
    var cantExpress= 0;
    var cantGratis =0;
    var cantProgramado =0;
    var cantAbierto =0;
    if(tipo=="EXPRESS")  cantExpress=1;
    if(tipo=="GRATIS") cantGratis=1;
    if(tipo=="PROGRAMADO") cantProgramado=1;
    if(tipo=="ABIERTO") cantAbierto=1;

     $.ajax({
      type: "POST",
      url: "/cart/update.js",
      dataType: "json",
      data: {
        updates: {
          43213443236063: cantExpress,
          43213440024799:  cantProgramado,
          43213437993183:  cantGratis,
          43255599562975:  cantAbierto,
        },
         attributes: attributes,
      },
      
      success: function (response) {
              console.log('Se enviaron');
              console.log(JSON.stringify({ attributes: attributes }));
              console.log('LlamadoProcesa *** '+ tipo);              
              Procesa( tipo, true);              
              return true;
            }
    });
  });
  	
}
function agregaDefault()
{
   const SmartCart = window.Rebuy.SmartCart;
  
  var env = SmartCart.items().find(({title})=>title.includes('Envío'));
  
  if(env != null)
  {
    /*console.log('envio encontrado, no agrega default'); console.log(env.title);*/
  }
  else
  {
  const sum = ObtenTotalSinEnvio();
   var CumpleMinimo = sum >= 150000;
   /*console.log('CumpleMinimo' + CumpleMinimo);  console.log('sum'+sum);*/
   var mm=new Date().getMonth()+1;
   var dd=new Date().getDate();
   if(sum>0)
   {
  if(CumpleMinimo)
  {
    //Gratis();
  }
  else    
  {  	
    //Abierto();
  }
   }
  }
}
function ActivaCheckout()
  {
    const SmartCart = window.Rebuy.SmartCart;
    //console.log('total -- ', SmartCart.subtotalNumber());
    try{
     if(SmartCart.items().length==0)
      {
         console.log("scrolleando vacio");
         if(document.getElementById('cartScroll'))
          {
     document.getElementById('cartScroll').scrollTo({ top: 0,
      left: 0,
      behavior: 'smooth'});                      
         }

      }
    }catch(error){console.log(error);}
    return (ObtenTotalSinEnvio()>=75000  && !MuestraAdvertenciaRango() && !MuestraAdvertenciaDia() && !BrillaSeleccioneTipoEnvio());
  }
  function ActivaCheckoutMinimo()
  {
    const SmartCart = window.Rebuy.SmartCart;
    return ObtenTotalSinEnvio()>=75000;
  }
  function BrillaSeleccioneTipoEnvio(){
    return botonActivo("");
  }
  function ScrollSeleccionaTipo ()
  {
        const SmartCart = window.Rebuy.SmartCart;
    if(SmartCart.subtotalNumber()>=75000)
    {document.getElementsByClassName("Brilla")[0].scrollIntoView({ block: 'center',  behavior: 'smooth'});}
    else
    {}
    
  }
  function ActualizaProgreso()
        {
          var prog = document.getElementById('progreso');
          
          if(prog)
          { 
            var tse = ObtenTotalSinEnvio();
            var textogoal = "";
            var porcentaje = 0;
            var txtprog = document.getElementById('textoprogreso');  
            var pedmin=75000;
            var envgrat=150000;
            var checkgratis=false;
            var checkmin = false;
            if(tse < pedmin )
            {
                var faltan = ((pedmin - tse)/100);
                textogoal = "¡Te faltan solo $"+faltan+" para el pedido mínimo!";
                porcentaje = (tse*100/pedmin)/2;                
            }
            else if(tse < envgrat)
            {
                checkmin = true;
                var faltan = ((envgrat - tse)/100);
                textogoal = "¡Te faltan solo $"+faltan+" para envío gratis!";
                porcentaje = 50 + (((tse-pedmin)*100/(envgrat - pedmin))/2);
            }
            else 
            { 
              checkmin = true;
               checkgratis=true;                            
               porcentaje = 100;
               textogoal = "¡Tienes envío gratis!";
            }
            if(txtprog)
              {
                txtprog.textContent = textogoal;
                console.log(textogoal);
              }
              var iconmin = document.getElementById('imgIconMin');  
              var iconenv = document.getElementById('imgIconEnv');  
              if(iconmin)
                {
                  if(checkmin)
                  {                  
                    
                    iconmin.src='//alacenademonica.com/cdn/shop/files/check.svg?v=1772811433';
                  }
                  else
                  {
                    
                    iconmin.src='//alacenademonica.com/cdn/shop/files/Pedido_Minimo.svg?v=1772661640';
                  }
                }
                if(iconenv)
                {
                  if(checkgratis)
                  {                  
                    iconenv.src='//alacenademonica.com/cdn/shop/files/check.svg?v=1772811433';
                  }
                  else
                  {
                    iconenv.src='//alacenademonica.com/cdn/shop/files/camion.svg?v=1772824787';
                  }
                }
            prog.style.width = porcentaje+"%";
          }
          
          console.log("progresoactualizado");
        }